const getPlatform = (): string | null => {
  const cookieName = 'flowhub.platform'
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()
    if (cookie.startsWith(cookieName + '=')) {
      const value = cookie.substring(cookieName.length + 1)
      return value
    }
  }
  return null
}

export const APP_TYPE: 'iOS' | 'electron' | 'browser' | 'windows' | 'android' =
  window.webkit
    ? 'iOS'
    : getPlatform() === 'windows.electron'
    ? 'windows'
    : window.electron
    ? 'electron'
    : getPlatform() === 'android'
    ? 'android'
    : 'browser'

/**
 * Does this device have a touch screen?
 *
 * `APP_TYPE` cannot answer this. It reports 'iOS' for any WKWebView wrapper —
 * including the macOS app, which has no touch screen — because it only looks
 * for `window.webkit`.
 *
 * `maxTouchPoints` is the load-bearing signal: 5 on an iPad, 0 on a Mac. It
 * keeps reporting the built-in screen when a Magic Keyboard is attached, which
 * flips the PRIMARY pointer to fine — so the corroborating query is
 * `any-pointer: coarse`, not `pointer: coarse`, which would go false on that
 * same iPad. A function rather than a constant so an input attached after load
 * is picked up on the next read.
 */
export const isTouchScreen = (): boolean => {
  if (navigator.maxTouchPoints > 0) return true
  return window.matchMedia?.('(any-pointer: coarse)').matches ?? false
}
